import React from 'react'
import {Form, Input, Select, Switch, TimePicker} from "antd"

import moment from "moment"
import {useClubTableBookSettingContext} from "../store/useClubTableBookSettingContext"

const BookSettingBase = () => {
    const minReservationDuration = []
    for (let i = 1; i <= 8; i++) {
        const duration = i * 30
        minReservationDuration.push({
            label: `${duration}分钟`,
            value: moment.duration(duration, 'minutes').toISOString()
        })
    }
    const {form, onCanReserveChange, getFieldValue, isShowReserve} = useClubTableBookSettingContext()

    return (
        <div>
            <Form
                form={form}
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                style={{width: '50%'}}
                initialValues={{
                    canReservation: false,
                    bookType: "1",
                    bookTime: [],
                    minReservationDuration: 'PT30M',
                    needAutomaticAccept: false
                }}
            >
                <Form.Item hidden={true} name={"id"}>
                    <Input/>
                </Form.Item>

                <Form.Item label={"开启自助预订"} name={"canReservation"} valuePropName={'checked'}>
                    <Switch></Switch>
                </Form.Item>
                {isShowReserve && <div>
                    <Form.Item
                        label={"预订类型"}
                        name={"bookType"}
                    >
                        <Select options={[{
                            label: "付费预订",
                            value: "1"
                        },]}></Select>
                    </Form.Item>
                    <Form.Item
                        label={"可预订时间"}
                        name={"bookTime"}
                        rules={isShowReserve ? [{required: true, message: '请选择可预订时间'}] : []}
                    >
                        <TimePicker.RangePicker
                            style={{width: '100%', height: '100%'}}
                            format="HH:mm"
                            minuteStep={30}
                            order={false}
                        ></TimePicker.RangePicker>
                    </Form.Item>
                    <Form.Item
                        label={"最低预订"}
                        name={"minReservationDuration"}
                    >
                        <Select options={minReservationDuration} placeholder={"请选择最低预订时长"}
                        ></Select>
                    </Form.Item>
                    <Form.Item label={"自动确认订单"} name={"needAutomaticAccept"} valuePropName={'checked'}>
                        <Switch/>
                    </Form.Item>
                </div>}
            </Form>
        </div>
    )
}

export default BookSettingBase


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/bookSettings/component/BookSettingBase.js